import { IAttribute, IViolation } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { SapTableDataset } from 'app/model/dataset/sap-table.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

import { TabularCopySource } from './tabular-type.copysource';
import { partitionOptionConst } from 'app/registries/consts/metadata-consts';
import { stringIsNullOrEmpty } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.sapTable.copySourceType,
    display: [],
    tags: {
        datasetModel: [
            Metamodel.modelFor(SapTableDataset)
        ]
    }
})
export class SapTableCopySource extends TabularCopySource {
    public static readonly ROW_COUNT: IAttribute;
    public static readonly ROW_SKIPS: IAttribute;
    public static readonly RFC_TABLE_FIELDS: IAttribute;
    public static readonly RFC_TABLE_OPTIONS: IAttribute;
    public static readonly CUSTOM_FUNCTION_MODULE: IAttribute;
    public static readonly BATCH_SIZE: IAttribute;

    public static readonly PARTITION_OPTION: IAttribute;

    public static readonly MAX_PARTITIONS_NUMBER: IAttribute;
    public static readonly PARTITION_COLUMN_NAME: IAttribute;
    public static readonly PARTITION_UPPER_BOUND: IAttribute;
    public static readonly PARTITION_LOWER_BOUND: IAttribute;

    public static readonly SAP_COLUMN_DELIMITER: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'ROW_COUNT',
        display: stringResources.RowCountLabel,
        constraint: {
            validator: SapTableCopySource.validateSapRowCountConflictPartition
        }
    })
    public rowCount?: number;

    @Metamodel.attribute({
        templatable: true,
        association: 'ROW_SKIPS',
        display: stringResources.ModelName_RowSkips
    })
    public rowSkips?: number;

    @Metamodel.attribute({
        templatable: true,
        association: 'RFC_TABLE_FIELDS',
        display: stringResources.ModelName_RfcTableFields
    })
    public rfcTableFields?: string[];

    @Metamodel.attribute({
        templatable: true,
        association: 'RFC_TABLE_OPTIONS',
        display: stringResources.ModelName_RfcTableOptions
    })
    public rfcTableOptions?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'CUSTOM_FUNCTION_MODULE',
        display: stringResources.ModelName_CustomRfcReadTableFunctionModule
    })
    public customRfcReadTableFunctionModule?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'BATCH_SIZE',
        display: stringResources.ModelName_BatchSize
    })
    public batchSize?: number;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_OPTION',
        display: stringResources.ModelName_Partition_Option,
        constraint: {
            validator: SapTableCopySource.validateSapRowCountConflictPartition
        }
    })
    public partitionOption?: string = partitionOptionConst.none;

    @Metamodel.attribute({
        templatable: true,
        association: 'MAX_PARTITIONS_NUMBER',
        display: stringResources.ModelName_MaxPartitionsNumber
    })
    public maxPartitionsNumber?: number;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_COLUMN_NAME',
        display: stringResources.ModelName_Partition_ColumnName
    })
    public partitionColumnName?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_UPPER_BOUND',
        display: stringResources.ModelName_Partition_UpperBound
    })
    public partitionUpperBound?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_LOWER_BOUND',
        display: stringResources.ModelName_Partition_LowerBound
    })
    public partitionLowerBound?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'SAP_COLUMN_DELIMITER',
        display: stringResources.ModelName_ColumnDelimiter,
        constraint: {
            validator: SapTableCopySource.validateSapDataColumnDelimiter
        }
    })
    public sapDataColumnDelimiter?: string;

    public static validateSapDataColumnDelimiter(copySource?: SapTableCopySource, value?: string): IViolation[] {
        const violations: IViolation[] = [];
        if (!stringIsNullOrEmpty(copySource.sapDataColumnDelimiter) && !(/^(\\u([0-9a-f]){4}|[^])$/.test(copySource.sapDataColumnDelimiter))) {
            violations.push({
                message: () => stringResources.Sap_ColumnDelimiter_ValidationError
            });
        }
        return violations;
    }

    public static validateSapRowCountConflictPartition(copySource?: SapTableCopySource, value?: string): IViolation[] {
        const violations: IViolation[] = [];
        if (copySource.rowCount != null && ![null, undefined, partitionOptionConst.none].includes(copySource.partitionOption)) {
            violations.push({
                message: () => stringResources.Sap_RowCount_Partition_Confilict_ValidationError
            });
        }
        return violations;
    }
}
